// extracted by mini-css-extract-plugin
export default {"block":"about-nav-text3_block__WM3dQ","title":"about-nav-text3_title__eFqRf","text":"about-nav-text3_text__m3mDU","link":"about-nav-text3_link__LRPrB"};